import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BANNERS_REQUEST = 'Banners/FETCH_BANNERS_REQUEST'
const FETCH_BANNERS_SUCCESS = 'Banners/FETCH_BANNERS_SUCCESS'
const FETCH_BANNERS_FAILURE = 'Banners/FETCH_BANNERS_FAILURE'

const CREATE_BANNERS_REQUEST = 'Banners/CREATE_BANNERS_REQUEST'
const CREATE_BANNERS_SUCCESS = 'Banners/CREATE_BANNERS_SUCCESS'
const CREATE_BANNERS_FAILURE = 'Banners/CREATE_BANNERS_FAILURE'

const UPDATE_BANNERS_REQUEST = 'Banners/UPDATE_BANNERS_REQUEST'
const UPDATE_BANNERS_SUCCESS = 'Banners/UPDATE_BANNERS_SUCCESS'
const UPDATE_BANNERS_FAILURE = 'Banners/UPDATE_BANNERS_FAILURE'

const DELETE_BANNERS_REQUEST = 'Banners/DELETE_BANNERS_REQUEST'
const DELETE_BANNERS_SUCCESS = 'Banners/DELETE_BANNERS_SUCCESS'
const DELETE_BANNERS_FAILURE = 'Banners/DELETE_BANNERS_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  bannersList: [],
}

// Default Reducer
const banners = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANNERS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BANNERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bannersList: action.payload
      }
    case FETCH_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BANNERS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BANNERS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BANNERS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BANNERS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BANNERS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BANNERS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default banners

// Action Creators
export const fetchBannersList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BANNERS_REQUEST
      })

      const response = await API.get(EndPoints.BANNERS+ `/getAll`)
      dispatch({
        type: FETCH_BANNERS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BANNERS_FAILURE
      })
    }
  }
}

export const createBanners = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BANNERS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.BANNERS+ `/createBanners`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_BANNERS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BANNERS_FAILURE
      })
    }
  }
}

export const updateBanners = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BANNERS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.BANNERS+ `/updateBanners`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_BANNERS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BANNERS_FAILURE
      })
    }
  }
}

export const deleteBanners = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BANNERS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.BANNERS + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_BANNERS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BANNERS_FAILURE
      })
    }
  }
}






